// extracted by mini-css-extract-plugin
export var marginNegative = "_72-5 _72-3 _72-1";
export var marginPositive = "_72-4 _72-3 _72-1";
export var modalContent = "_72-6";
export var samplesTable = "_72-8";
export var samplesTableContainer = "_72-7";
export var statBox = "_72-a";
export var tableCell = "_72-1";
export var tableCellCenter = "_72-2 _72-1";
export var tableCellRight = "_72-3 _72-1";
export var tableHeader = "_72-0";
export var trackingNumber = "_72-9";